interface StatusBadgeProps {
  status: string;
  className?: string;
}

const statusStyles: Record<string, string> = {
  active: "bg-success/10 text-success",
  approved: "bg-success/10 text-success",
  APPROVED: "bg-success/10 text-success",
  completed: "bg-success/10 text-success",
  COMPLETED: "bg-success/10 text-success",
  paid: "bg-success/10 text-success",
  PAID: "bg-success/10 text-success",
  published: "bg-success/10 text-success",
  PUBLISHED: "bg-success/10 text-success",
  pending: "bg-warning/10 text-warning",
  PENDING: "bg-warning/10 text-warning",
  expiring: "bg-warning/10 text-warning",
  advance_paid: "bg-info/10 text-info",
  confirmed: "bg-info/10 text-info",
  CONFIRMED: "bg-info/10 text-info",
  active_status: "bg-info/10 text-info",
  ACTIVE: "bg-info/10 text-info",
  TRIALING: "bg-info/10 text-info",
  trialing: "bg-info/10 text-info",
  PAST_DUE: "bg-warning/10 text-warning",
  past_due: "bg-warning/10 text-warning",
  GRACE_PERIOD: "bg-warning/10 text-warning",
  grace_period: "bg-warning/10 text-warning",
  PAUSED: "bg-muted text-muted-foreground",
  paused: "bg-muted text-muted-foreground",
  INCOMPLETE: "bg-warning/10 text-warning",
  incomplete: "bg-warning/10 text-warning",
  suspended: "bg-destructive/10 text-destructive",
  SUSPENDED: "bg-destructive/10 text-destructive",
  rejected: "bg-destructive/10 text-destructive",
  REJECTED: "bg-destructive/10 text-destructive",
  cancelled: "bg-destructive/10 text-destructive",
  CANCELLED: "bg-destructive/10 text-destructive",
  expired: "bg-destructive/10 text-destructive",
  EXPIRED: "bg-destructive/10 text-destructive",
  refund_pending: "bg-warning/10 text-warning",
  refunded: "bg-muted text-muted-foreground",
  REFUNDED: "bg-muted text-muted-foreground",
  flagged: "bg-destructive/10 text-destructive",
  FLAGGED: "bg-destructive/10 text-destructive",
  removed: "bg-muted text-muted-foreground",
  REMOVED: "bg-muted text-muted-foreground",
};

const labelMap: Record<string, string> = {
  advance_paid: "Advance Paid",
  refund_pending: "Refund Pending",
  PAST_DUE: "Past Due",
  past_due: "Past Due",
  GRACE_PERIOD: "Grace Period",
  grace_period: "Grace Period",
};

export const StatusBadge = ({ status, className = "" }: StatusBadgeProps) => {
  const normalized = status?.toString() ?? "";
  const style = statusStyles[normalized] || "bg-muted text-muted-foreground";
  const label =
    labelMap[normalized] || normalized.replace(/_/g, " ").toLowerCase();
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-btn text-xs font-semibold capitalize ${style} ${className}`}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
